export const languages = [
  {
    icon: "fab fa-java",
    name: "Java",
    level: 90,
  },
  {
    icon: "fab fa-js-square",
    name: "JavaScript",
    level: 90,
  },
  {
    icon: "fab fa-python",
    name: "Python",
    level: 70,
  },
  {
    icon: "fab fa-angular",
    name: "Angular",
    level: 80,
  },
  {
    icon: "fab fa-react",
    name: "React",
    level: 90,
  },
  {
    icon: "fab fa-node-js",
    name: "Node.js",
    level: 80,
  },
  {
    icon: "devicon-csharp-plain",
    name: "C#/.NET",
    level: 50,
  },
  {
    icon: "fas fa-database",
    name: "SQL",
    level: 90,
  },
  {
    icon: "fab fa-sass",
    name: "SaSS",
    level: 70,
  },
  {
    icon: "fab fa-android",
    name: "Android/Flutter",
    level: 80,
  },
  {
    icon: "fab fa-bootstrap",
    name: "Bootstrap",
    level: 80,
  },
  {
    icon: "fas fa-database",
    name: "PL-SQL",
    level: 90,
  },
  {
    icon: "fab fa-yammer",
    name: "YAML",
    level: 70,
  },
  {
    icon: "fab fa-linux",
    name: "Shell/Curl Script",
    level: 50,
  },
];

export const tools = [
  {
    icon: "devicon-git-plain",
    name: "GIT",
    level: 90,
  },
  {
    icon: "devicon-github-plain",
    name: "GitHub",
    level: 90,
  },
  {
    icon: "devicon-gitlab-plain",
    name: "GitLab",
    level: 80,
  },
  {
    icon: "devicon-bitbucket-original",
    name: "Bitbucket",
    level: 80,
  },
  {
    icon: "devicon-visualstudio-plain",
    name: "Visual Studio",
    level: 80,
  },
  {
    icon: "devicon-amazonwebservices-plain",
    name: "AWS",
    level: 50,
  },
  {
    icon: "fab fa-microsoft",
    name: "Azure",
    level: 80,
  },
  {
    icon: "fab fa-jira",
    name: "JIRA",
    level: 80,
  },
  {
    icon: "fab fa-npm",
    name: "NPM",
    level: 80,
  },
  { 
    icon: "devicon-webpack-plain", 
    name: "Webpack",
    level: 80,
  },
  {
    icon: "fab fa-docker",
    name: "Docker",
    level: 70,
  },
  {
    icon: "fas fa-dharmachakra",
    name: "Kubernetes",
    level: 50,
  },
  {
    icon: "fab fa-jenkins",
    name: "Jenkins",
    level: 70,
  },
  {
    icon: "fas fa-fire-alt",
    name: "Firebase",
    level: 50,
  },
];

export const other = [
  {
    icon: "devicon-photoshop-plain",
    name: "Photoshop",
    level: 80,
  },
  {
    icon: "far fa-compass",
    name: "Postman",
    level: 90,
  },
  {
    icon: "fab fa-microsoft",
    name: "Office 365",
    level: 80,
  },
  {
    icon: "fas fa-terminal",
    name: "PowerShell / Terminal",
    level: 70,
  },
  {
    icon: "fas fa-bug",
    name: "Selenium",
    level: 60,
  },
  {
    icon: "fas fa-lock",
    name: "OAuth / JWT",
    level: 90,
  },
  {
    icon: "fas fa-file-code",
    name: "Swagger / OpenAPI",
    level: 80,
  },
  {
    icon: "fas fa-cloud",
    name: "CI/CD Pipelines",
    level: 70,
  },
];
